import type { PoDraftLine } from "@/components/manufacturing/purchaseOrderDraftState";

export const PO_DRAFT_VERSION = 1 as const;

export type PurchaseOrderOfflineDraft = {
  version: typeof PO_DRAFT_VERSION;
  saved_at: string;
  organization_id: string;
  plant_id: string;
  vendor_id: string;
  vendor_name: string;
  ship_to: string;
  po_date: string;
  confirmation: string;
  lines: PoDraftLine[];
  cc_emails?: string[];
};

function storageKey(organizationId: string): string {
  return `mfg:purchase-order-draft:v1:${organizationId}`;
}

export function savePurchaseOrderOfflineDraft(draft: PurchaseOrderOfflineDraft): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(storageKey(draft.organization_id), JSON.stringify(draft));
  } catch {
    // quota / private mode
  }
}

export function loadPurchaseOrderOfflineDraft(
  organizationId: string,
): PurchaseOrderOfflineDraft | null {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(storageKey(organizationId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PurchaseOrderOfflineDraft;
    if (parsed?.version !== PO_DRAFT_VERSION || !Array.isArray(parsed.lines)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPurchaseOrderOfflineDraft(organizationId: string): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.removeItem(storageKey(organizationId));
  } catch {
    // ignore
  }
}
